var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountFsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 558,
    viewBox: "0 0 558 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7261_20420)",
    filter: "url(#filter0_d_7261_20420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279 550C430.878 550 554 426.878 554 275C554 123.122 430.878 0 279 0C127.122 0 4 123.122 4 275C4 426.878 127.122 550 279 550Z",
    fill: "#FFF5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.521 208.276H73.6015C63.8804 208.276 55.9999 216.156 55.9999 225.878V324.13C55.9999 333.851 63.8804 341.731 73.6015 341.731H482.521C492.242 341.731 500.123 333.851 500.123 324.13V225.878C500.123 216.156 492.242 208.276 482.521 208.276Z",
    fill: "#EF6051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.854 51.4318H228.602C218.881 51.4318 211 59.3123 211 69.0334V477.953C211 487.674 218.881 495.555 228.602 495.555H326.854C336.575 495.555 344.455 487.674 344.455 477.953V69.0334C344.455 59.3123 336.575 51.4318 326.854 51.4318Z",
    fill: "#EF6051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.391 278.027L417.609 278.027V268.966L140.391 268.966V278.027Z",
    fill: "#1C1550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.57 109.883H186.43C179.614 109.883 174.088 115.41 174.088 122.225V273.493H383.912V122.225C383.912 115.41 378.386 109.883 371.57 109.883Z",
    fill: "#150050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.005 195.708C204.525 195.708 209.812 190.422 209.812 183.901C209.812 177.38 204.525 172.094 198.005 172.094C191.484 172.094 186.197 177.38 186.197 183.901C186.197 190.422 191.484 195.708 198.005 195.708Z",
    fill: "#5E85FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.698 179.015C221.219 179.015 226.505 173.729 226.505 167.208C226.505 160.687 221.219 155.401 214.698 155.401C208.177 155.401 202.891 160.687 202.891 167.208C202.891 173.729 208.177 179.015 214.698 179.015Z",
    fill: "#EF6051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.005 162.322C204.525 162.322 209.812 157.036 209.812 150.515C209.812 143.994 204.525 138.707 198.005 138.707C191.484 138.707 186.197 143.994 186.197 150.515C186.197 157.036 191.484 162.322 198.005 162.322Z",
    fill: "#5E85FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.778 162.322C271.299 162.322 276.585 157.036 276.585 150.515C276.585 143.994 271.299 138.707 264.778 138.707C258.257 138.707 252.971 143.994 252.971 150.515C252.971 157.036 258.257 162.322 264.778 162.322Z",
    fill: "#FACF18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.085 179.015C254.605 179.015 259.892 173.729 259.892 167.208C259.892 160.687 254.605 155.401 248.085 155.401C241.564 155.401 236.277 160.687 236.277 167.208C236.277 173.729 241.564 179.015 248.085 179.015Z",
    fill: "#FA9BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.778 195.708C271.299 195.708 276.585 190.422 276.585 183.901C276.585 177.38 271.299 172.094 264.778 172.094C258.257 172.094 252.971 177.38 252.971 183.901C252.971 190.422 258.257 195.708 264.778 195.708Z",
    fill: "#FACF18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.698 145.628C221.219 145.628 226.505 140.342 226.505 133.821C226.505 127.3 221.219 122.014 214.698 122.014C208.177 122.014 202.891 127.3 202.891 133.821C202.891 140.342 208.177 145.628 214.698 145.628Z",
    fill: "#5E85FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.391 162.322C237.912 162.322 243.198 157.036 243.198 150.515C243.198 143.994 237.912 138.707 231.391 138.707C224.87 138.707 219.584 143.994 219.584 150.515C219.584 157.036 224.87 162.322 231.391 162.322Z",
    fill: "#FA9BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.892 133.821C259.892 140.341 254.604 145.628 248.085 145.628C241.565 145.628 236.277 140.341 236.277 133.821C236.277 127.302 241.565 122.014 248.085 122.014C254.604 122.014 259.892 127.302 259.892 133.821Z",
    fill: "#FACF18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.085 212.402C254.605 212.402 259.892 207.116 259.892 200.595C259.892 194.074 254.605 188.787 248.085 188.787C241.564 188.787 236.277 194.074 236.277 200.595C236.277 207.116 241.564 212.402 248.085 212.402Z",
    fill: "#FACF18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.391 195.708C237.912 195.708 243.198 190.422 243.198 183.901C243.198 177.38 237.912 172.094 231.391 172.094C224.87 172.094 219.584 177.38 219.584 183.901C219.584 190.422 224.87 195.708 231.391 195.708Z",
    fill: "#EF6051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.698 212.402C221.219 212.402 226.505 207.116 226.505 200.595C226.505 194.074 221.219 188.787 214.698 188.787C208.177 188.787 202.891 194.074 202.891 200.595C202.891 207.116 208.177 212.402 214.698 212.402Z",
    fill: "#5E85FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.928 136.095L369.162 144.988V138.764L365.741 137.525V129.921L369.162 129.203V123.718L346.245 128.499V133.561C346.245 134.694 346.907 135.659 347.928 136.081V136.095ZM361.045 130.906V135.821L352.441 132.702L361.045 130.906V130.906Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.245 166.694L369.162 171.594V165.666L346.245 160.766V166.694Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.245 175.46L361.84 181.627L348.576 184.127C347.097 184.415 346.238 185.577 346.238 186.858V196.948L346.907 197.088C347.358 195.018 348.083 192.667 348.857 191.245C349.329 190.372 349.744 190.125 350.871 189.837L369.155 185.112V178.846L346.238 169.243V175.474L346.245 175.46Z",
    fill: "#FFF6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.405 159.146C356.7 159.182 358.545 156.203 359.643 153.957C360.763 151.648 361.488 150.874 362.488 150.881C364.023 150.895 364.706 152.725 364.727 154.429C364.776 157.407 363.924 159.139 363.283 160.519L368.303 161.597C368.937 160.21 369.493 157.654 369.521 154.999C369.521 148.776 366.445 144.699 361.678 144.678C355.63 144.657 355.299 153.042 352.596 152.986C351.772 152.972 350.899 152.183 350.674 150.472C350.561 149.62 350.477 147.283 351.702 144.622L346.844 143.58C346.323 145.002 345.83 146.839 345.83 149.128C345.83 154.985 348.942 159.111 353.405 159.146V159.146Z",
    fill: "#FFF6E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7261_20420",
    x: 0,
    y: 0,
    width: 558,
    height: 558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7261_20420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7261_20420",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7261_20420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 550,
    height: 550,
    fill: "white",
    transform: "translate(4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountFsa);
export default __webpack_public_path__ + "static/media/account-fsa.bc67a4df17aee7660b0a30ae263600d9.svg";
export { ForwardRef as ReactComponent };